<template>
  <div :class="$style.container">
    <img :src="contactPhotoUrl" alt="" />
    <div :class="$style.customer">
      <p>{{contactName}}</p>
      <p v-if="contactPosition">{{contactPosition}}</p>
      <p v-if="contactOrganization">{{contactOrganization}}</p>
    </div>
    <call-duration :class="$style.callDuration" />
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import CallDuration from '../../rep-call/call-duration/call-duration'

  const { mapGetters } = createNamespacedHelpers('conference')

  export default {
    components: {
      CallDuration
    },
    computed: mapGetters([
      'contactName',
      'contactPhotoUrl',
      'contactPosition',
      'contactOrganization'
    ])
  }
</script>

<style module lang="less" src="./call-info.less"></style>



// WEBPACK FOOTER //
// call-info.vue?2f568fe6